export const formatAnnouncementDate = (announcement) => {
  if (announcement?.scheduleDate) {
    return (
      announcement.scheduleDate?.toDate?.() ??
      new Date(announcement.scheduleDate)
    );
  }

  const createdDate = announcement?.createdAt?.toDate?.();

  if (createdDate) {
    return createdDate;
  }

  return null;
};
